import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Home } from "@/pages/Home";
import { About } from "@/pages/About";
import { Projects } from "@/pages/Projects";
import { Contact } from "@/pages/Contact";
import { Appointment } from "@/pages/Appointment";
import { Admin } from "@/pages/Admin";
import { Scripting } from "@/pages/Scripting";
import { SaadPortfolio } from "@/pages/SaadPortfolio";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppLayout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const isScripting = pathname.startsWith("/scripting");
  const isPortfolio = pathname.startsWith("/portfolio");
  
  return (
    <>
      {!isAdmin && !isScripting && !isPortfolio && <Navigation />}
      <main>{children}</main>
      {!isAdmin && !isScripting && !isPortfolio && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AppLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/appointment" element={<Appointment />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/scripting" element={<Scripting />} />
            <Route path="/portfolio" element={<SaadPortfolio />} />
          </Routes>
        </AppLayout>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
